<div [ngClass]="isVerticalList ? 'reportListVertical' : 'reportListButton'" id="reportListButton" *ngIf="_hasReportsWithPermissions">

    <!-- Botón principal para abrir el menú, si es vertical no es un boton -->
    <button *ngIf="!isVerticalList" class="btnMore" mat-icon-button [matMenuTriggerFor]="menu" matTooltipPosition="above">
      <img src="/assets/img/icon_puntitos.png">
    </button>

    <!-- Menú principal de acciones -->
    <mat-menu #menu="matMenu">
      <button *ngIf="showReportes" class="mat-button" mat-menu-item [matMenuTriggerFor]="menuReportes" [disabled]="reportList.length == 0">
        <!-- <mat-icon>assignment_returned</mat-icon> -->
        <img [src]="'reportes_naranja.svg' | findUrl">
        <span>Reportes</span>
      </button>

      <button *ngIf="editGeofences" class="mat-button" mat-menu-item [matMenuTriggerFor]="editAcciones" [disabled]="geofenceActionList.length == 0">
        <span>Acciones</span>
      </button>

      <button *ngIf="showReportes" class="mat-button" mat-menu-item [matMenuTriggerFor]="menuGeoProcesos" [disabled]="geoprocessActionList.length == 0">
        <!-- <mat-icon>assignment_returned</mat-icon> -->
        <img [src]="'geoprocesos.svg' | findUrl">
        <span>GeoProcesos</span>
      </button>
    </mat-menu>

    <!-- Menú secundario que se muestra al hacer hover sobre la opción de reportes -->
    <mat-menu #menuReportes="matMenu">
      <!-- Reportes para control llamado desde Control de Activos -->
      <button #globalL class="mat-button" mat-menu-item (click)="onClickDownloadReportHistGlobal()" *ngIf="isGlobal && 'Hist.Global-L' | permissionFilter">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Hist. Global</span>
      </button>
      <button #lastLocationsAllVINs class="mat-button" mat-menu-item (click)="onClickReportLastLocationsAllVINs()" *ngIf="isGlobal && 'AllVinLastPos-L' | permissionFilter">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Últimas Ubicaciones (Todos los activos)</span>
      </button>
      <button #movimientosL class="mat-button" mat-menu-item (click)="onClickReportMenuHistMov()" *ngIf="isFromLocation && ('Hist.Movimientos-L' | permissionFilter) && (isMovementHistoricalAllowed)" >
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Hist. de Movimientos</span>
      </button>
      <button #conduccionL class="mat-button" mat-menu-item (click)="onClickReportMenuHabit()" *ngIf="isFromLocation && ('Habit.Conduccion-L' | permissionFilter) && (isDriverBehaviorAllowed)">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Hábitos de Conducción</span>
      </button>
      <button #manejoL class="mat-button" mat-menu-item (click)="onClickReportMenuStats()" *ngIf="isFromLocation && ('Estad.Manejo-L' | permissionFilter) && (isDriverStatisticsAllowed)">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Estadisticos de Manejo</span>
      </button>

      <!-- Reportes para control llamado desde Rutas -->
      <button #movimientosR class="mat-button" mat-menu-item (click)="onClickReportMenuHistMov()" *ngIf="isRutas && 'Hist.Movimientos-R' | permissionFilter">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Hist. de Movimientos</span>
      </button>
      <button #conduccionR class="mat-button" mat-menu-item (click)="onClickReportMenuHabit()" *ngIf="isRutas && 'Habit.Conduccion-R' | permissionFilter">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Hábitos de Conducción</span>
      </button>
      <button #manejoR class="mat-button" mat-menu-item (click)="onClickReportMenuStats()" *ngIf="isRutas && 'Estad.Manejo-R' | permissionFilter">
        <img [src]="'reportes_naranja.svg' | findUrl" width="25px">
        <span>Estadisticos de Manejo</span>
      </button>
    </mat-menu>

    <!-- Menú secundario para geocercas-->
    <mat-menu #editAcciones="matMenu">
      <!-- Opciones para control llamado desde geocercas (ahora en el tool bar, pero aqui se ueden añadir otras accciones) -->
      <!-- <button #addGeofence *ngIf="!isGeofenceDetails && 'AgregarGeocerca' | permissionFilter" mat-menu-item (click)="onClickEditGeofence()">
       <img src="assets/images/icon_plus.png" style="width: 25px;">
        <span>Crear</span>
      </button>
      <button #editGeofence *ngIf="isGeofenceDetails && 'EditarGeocerca' | permissionFilter" mat-menu-item (click)="onClickEditGeofence()">
        <mat-icon>edit</mat-icon>
        <span>Editar</span>
      </button>
      <button #cloneGeofence *ngIf="isGeofenceDetails && 'DuplicarGeocerca' | permissionFilter" mat-menu-item (click)="onClickDuplicateGeofence()">
        <mat-icon>control_point_duplicate</mat-icon>
        <span>Duplicar</span>
      </button>
      <button #deleteGeofence *ngIf="isGeofenceDetails && 'BorrarGeocerca' | permissionFilter" mat-menu-item (click)="onClickDeleteGeofence()">
        <mat-icon>delete</mat-icon>
        <span>Borrar</span>
      </button> -->
    </mat-menu>

    <!-- Menú secundario para geoProcesos -->
    <mat-menu #menuGeoProcesos="matMenu">
      <button #geoPFrecuencyL class="mat-button" mat-menu-item (click)="openRecurrentPlaces()" *ngIf="isFromLocation && 'Lugares.Recurrentes-G' | permissionFilter">
        <!-- <img src="/assets/img/icon_download_xls.png" width="25px"> -->
         <img [src]="'geoprocesos_2.svg' | findUrl">
        <span>Lugares frecuentes</span>
      </button>

    </mat-menu>





    <!-- Botónes, si es vertical no es un boton -->
    <div *ngIf="isVerticalList" class="tools-buttons-vertical-container">
      <div class="vertical-tools">

        <!-- reportes -->
        <div *ngIf="isVerticalList && showReportes && reportList.length != 0" class="btnMoreVertical" [matMenuTriggerFor]="menuReportes">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Reportes ></span>
        </div>

        <!-- <div *ngIf="isVerticalList && showReportes && isGlobal && 'Hist.Global-L' | permissionFilter" class="btnMoreVertical" (click)="onClickDownloadReportHistGlobal()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Hist. Global</span>
        </div>

        <div *ngIf="isVerticalList && showReportes && isFromLocation && 'Hist.Movimientos-L' | permissionFilter" class="btnMoreVertical" (click)="onClickReportMenuHistMov()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Hist. de Movimientos</span>
        </div>
        <div *ngIf="isVerticalList && showReportes && isFromLocation && 'Habit.Conduccion-L' | permissionFilter" class="btnMoreVertical" (click)="onClickReportMenuHabit()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Hábitos de Conducción</span>
        </div>
        <div *ngIf="isVerticalList && showReportes && isFromLocation && 'Estad.Manejo-L' | permissionFilter" class="btnMoreVertical" (click)="onClickReportMenuStats()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Estadisticos de Manejo</span>
        </div>

        <div *ngIf="isVerticalList && showReportes && isRutas && 'Hist.Movimientos-R' | permissionFilter" class="btnMoreVertical" (click)="onClickReportMenuHistMov()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Hist. de Movimientos</span>
        </div>
        <div *ngIf="isVerticalList && showReportes && isRutas && 'Habit.Conduccion-R' | permissionFilter" class="btnMoreVertical" (click)="onClickReportMenuHabit()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Hábitos de Conducción</span>
        </div>
        <div *ngIf="isVerticalList && showReportes && isRutas && 'Estad.Manejo-R' | permissionFilter" class="btnMoreVertical" (click)="onClickReportMenuStats()">
          <img [src]="'reportes_naranja.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Estadisticos de Manejo</span>
        </div> -->


        <!-- acciones -->
        <div *ngIf="isVerticalList && editGeofences && geofenceActionList.length != 0" class="btnMoreVertical" [matMenuTriggerFor]="editAcciones">
          <img [src]="'menu_hamburguesa.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Acciones ></span>
        </div>

        <!-- geoprocesos -->
        <div *ngIf="isVerticalList && showReportes && geoprocessActionList.length != 0" class="btnMoreVertical" [matMenuTriggerFor]="menuGeoProcesos">
          <img [src]="'geoprocesos.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">GeoProcesos ></span>
        </div>

        <!-- <div *ngIf="isVerticalList && showReportes && isFromLocation && 'Lugares.Recurrentes-G' | permissionFilter" class="btnMoreVertical" (click)="openRecurrentPlaces()">
          <img [src]="'geoprocesos.svg' | findUrl">
          <span *ngIf="isVerticalList" class="tool-label">Lugares frecuentes</span>
        </div> -->
      </div>
    </div>
    

</div>